import { Just, Maybe, Nothing } from "purify-ts";

export const tryToParseInt = (
  value: null | string | undefined
): Maybe<number> => {
  const parsed = parseInt(value ?? "", 10);
  if (isNaN(parsed)) {
    return Nothing;
  }
  return Just(parsed);
};
